import { render, staticRenderFns } from "./ForumDetailedView.vue?vue&type=template&id=5d52bc24"
import script from "./ForumDetailedView.vue?vue&type=script&lang=js"
export * from "./ForumDetailedView.vue?vue&type=script&lang=js"
import style0 from "./ForumDetailedView.vue?vue&type=style&index=0&id=5d52bc24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports